module.exports = __webpack_public_path__ + "img/s26.464d883.png";